
import PropTypes from 'prop-types';
import RequiredPosition from './RequiredPosition';

export default PropTypes.shape({
  id: PropTypes.number,
  locationTypeName: PropTypes.string,
  bookingPriority: PropTypes.number,
  callTime: PropTypes.string,
  wrapTime: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  requiredPositions: PropTypes.arrayOf(RequiredPosition)
})